// Expose SweetAlert2 globally
// so that following imports in application.js have access to `Swal`

import Swal from 'sweetalert2';
window.Swal = Swal;
